import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class NetworkErrorWatcherService {

  public errors: Subject<number> = new Subject<number>();

  public broadcastError(e: number) {
    this.errors.next(e);
  }
}
